import { render, staticRenderFns } from "./WordTable.vue?vue&type=template&id=6e2b9280&"
import script from "./WordTable.vue?vue&type=script&lang=ts&"
export * from "./WordTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports